<template>
	<div class="page-content">
		<Breadcrumb :breadcrumbArray="breadcrumbArray"></Breadcrumb>
		<div class="drawer-subtitle g-between">
			<span class="drawer-subtitle-text">违规通知整改与复查数据概览</span>
			<div>
				<el-radio-group @change="onTimeChange" v-model="time" size="mini">
					<el-radio-button label="今日"></el-radio-button>
					<el-radio-button label="近7日"></el-radio-button>
					<el-radio-button label="近30日"></el-radio-button>
					<el-radio-button label="全年"></el-radio-button>
				</el-radio-group>
				<el-date-picker style="width: 360px;" size="mini" value-format="yyyy-MM-dd HH:mm:ss"
					v-model="committime" type="daterange" range-separator="~" start-placeholder="开始日期"
					end-placeholder="结束日期" @change="load" :picker-options="pickerOptions">
				</el-date-picker>
			</div>
		</div>

		<el-card class="out-review-summary out-review-card" :body-style="{ padding: '0px' }" shadow="nerver">
			<el-row :gutter="10">
				<el-col class="g-column-center complaint-item" :span="6">
					<span>
						通知整改商品链接数
					</span>
					<span class="out-review-number" v-if="outNotificationData && outNotificationData.cas1">
						{{ outNotificationData.cas1 }}
					</span>
					<span class="out-review-number" v-else>
						0
					</span>
				</el-col>
				<el-col class="g-column-center" :span="6">
					<span>
						复查合格商品链接数
					</span>
					<span class="out-review-number" v-if="outNotificationData && outNotificationData.cas3">
						{{ outNotificationData.cas2 }}
					</span>
					<span class="out-review-number" v-else>
						0
					</span>
					<span>
						{{ outNotificationData.cas4 }}%
					</span>
				</el-col>
				<el-col class="g-column-center" :span="6">
					<span>
						复查不合格商品链接数
					</span>
					<span class="out-review-number" v-if="outNotificationData && outNotificationData.cas2">
						{{ outNotificationData.cas3 }}
					</span>
					<span class="out-review-number" v-else>
						0
					</span>
					<span>
						{{ outNotificationData.cas5 }}%
					</span>
				</el-col>
				<el-col class="g-column-center" :span="6">
					<span @click="onTurnToDetail" class="out-review-btn">
						查看违规通知详情
					</span>
				</el-col>
			</el-row>
		</el-card>

		<el-row :gutter="10">
			<el-col :span="12">
				<p class="drawer-subtitle">
					<span class="drawer-subtitle-text">违规通知整改商品链接所属平台占比</span>
				</p>
				<el-card class="out-review-card" :body-style="{ padding: '20px' }" shadow="nerver">
					<el-radio-group class="out-review-btn-group" size="mini" v-model="picState" @change="load(1)">
						<el-radio-button label="1">已通知</el-radio-button>
						<el-radio-button label="2">复查合格</el-radio-button>
						<el-radio-button label="3">复查不合格</el-radio-button>
					</el-radio-group>
					<!-- <div v-show="noData" style="width: 100%; height: 400px;z-inde: 50000;">
						<div style="position: relative;top: 29%;left: 45%;">
							<img src="@/assets/img/other/nodata.svg">
						</div>

						<div style="position: relative;top: 29%;left: 45.5%;color: #909399;">
							暂无数据
						</div>
					</div> -->

					<div id="out-notification-chart" style="width: 90%; height: 400px;">

					</div>
				</el-card>
			</el-col>
			<el-col :span="12">
				<p class="drawer-subtitle">
					<span class="drawer-subtitle-text">违规通知整改商品链接所属店铺排名</span>
				</p>
				<el-card class="out-review-card" :body-style="{ padding: '20px' }" shadow="nerver"
					style="height: 468px; overflow: auto;">
					<i @click="download" class="el-icon-download out-review-download"></i>
					<el-radio-group class="out-review-btn-group" size="mini" v-model="tableState" @change="load">
						<el-radio-button label="1">已通知</el-radio-button>
						<el-radio-button label="2">复查合格</el-radio-button>
						<el-radio-button label="3">复查不合格</el-radio-button>
					</el-radio-group>
					<el-select size="mini" v-model="shoptype" placeholder="店铺性质" @change='load' clearable
						style="margin-left: 20px;">
						<el-option v-for="(item, i) in typeArr" :key="i" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-table class="g-margin-top" :data="outNotificationList">
						<el-table-column label="排名">
							<template slot-scope="scope">
								<div :class="isThreeInList(scope.$index) ? 'out-rank-three' : 'out-rank'">
									{{ indexMethod(scope.$index) }}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="平台" prop="dict_name">
						</el-table-column>
						<el-table-column label="店铺" prop="shopname">
						</el-table-column>
						<el-table-column label="店铺性质">
							<template slot-scope="scope">
								<span>
									{{ scope.row.shoptype ? scope.row.shoptype : '其他' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column label="链接数" prop="linkcount">
						</el-table-column>
					</el-table>

					<Pagination v-if="totalPage > 0" class="pagination" :total="totalPage" v-model="pagination"
						@onChange='load' />
				</el-card>
			</el-col>
		</el-row>

	</div>
</template>

<script>
import Breadcrumb from 'components/breadcrumb/breadcrumb';
import Pagination from 'components/pagination/pagination2';
import echarts from 'echarts';
import { mapActions, mapState } from 'vuex';
import { getRecentOneMonth, getTodayTimestamps, getRecentSevenDay, getRecentOneYear } from '@/libs/date';
export default {
	name: 'OutNotification',

	components: {
		Breadcrumb,
		Pagination,
	},

	data() {
		return {
			shoptype: '',
			typeArr: [
				{
					label: '全部',
					value: '',
				}, {
					label: '灰名单',
					value: '灰名单',
				}, {
					label: '黑名单',
					value: '黑名单',
				}, {
					label: '授权店铺',
					value: '授权店铺',
				}
			],
			noData: false,
			nameData: [
				{ value: '1688', name: '1688' },
				{ value: 'DD', name: '当当' },
				{ value: 'JD', name: '京东商城' },
				{ value: 'TB', name: '淘宝网' },
				{ value: 'TM', name: '天猫商城' },
				{ value: 'WPH', name: '唯品会' },
				{ value: 'YFW', name: '药房网' },
				{ value: 'YYC', name: '1药城' },
				{ value: 'PDD', name: '拼多多' },
				{ value: 'SN', name: '苏宁' },
				// { value: 'LZDVN', name: 'lazada-越南' },
				// { value: 'LZDSG', name: 'lazada-新加坡' },
				// { value: 'LZDMY', name: 'lazada-马来西亚' },
				{ value: 'platform_OTHER', name: '其他平台' },
			],
			pickerOptions: {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
							picker.$emit('pick', [start, start]);
						}
					}, {
						text: '近7日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '近15日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '近30日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: "近90日",
						onClick: picker => {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '近365日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},
			text: '0',
			totalPage: 0,
			pagination: {
				size: 5,
				current: 1
			},
			time: '近30日',
			picState: '1',
			tableState: '1',
			breadcrumbArray: ['智慧服务', '违规通知复查'],
			committime: [],
			// option:
		}
	},

	methods: {
		download() {
			let url = `hcm/wechatnotice/exportExcelShoplist?begintime=${this.committime[0]}&endtime=${this.committime[1]}`
			let params = {
				pageNo: this.pagination.current,
				pageSize: this.pagination.size,
				result: this.tableState,
				shoptype: this.shoptype
			}
			for (let i in params) {
				url = url + '&' + i + '=' + params[i]
			}
			console.log(url);

			window.open(url)
		},
		isThreeInList(index) {
			if (this.pagination.current === 1 && (index === 0 || index === 1 || index === 2)) {
				return true
			} else {
				return false
			}
		},
		indexMethod(index) {
			return index + (this.pagination.current - 1) * this.pagination.size + 1;
		},
		onTimeChange(v) {
			if (v === '全年') {
				this.committime = getRecentOneYear();
			} else if (v === '近7日') {
				this.committime = getRecentSevenDay();
			} else if (v === '近30日') {
				this.committime = getRecentOneMonth();
			} else {
				this.committime = getTodayTimestamps();
			}
			this.load();
		},
		...mapActions([
			'reqOutNotification',
			'reqOutNotificationList',
		]),
		load(e) {
			if (e) {
				this.pagination.current = 1
				this.pagination.size = 5
			}
			let params = {
				begintime: this.committime[0].substring(0, 10),
				endtime: this.committime[1].substring(0, 10),
				result: this.tableState,
				pageNo: this.pagination.current,
				pageSize: this.pagination.size,
				shoptype: this.shoptype
			}
			this.reqOutNotificationList(params).then(res => {
				this.totalPage = res.totalElements;
			});
			let params1 = {
				begintime: this.committime[0].substring(0, 10),
				endtime: this.committime[1].substring(0, 10),
				result: this.picState
			}
			this.reqOutNotification(params1)
				.then(res => {
					console.log(res)
					console.log(this.noData)
					if (!res) {
						console.log(this.noData)
						this.noData = true
						console.log(this.noData)
						return
					} else {
						console.log(this.noData)
						this.noData = false
						console.log(this.noData)
					}
					let element = document.getElementById('out-notification-chart');
					const chart = echarts.init(element);
					window.addEventListener("resize", function () {
						chart.resize();
					});
					let state = this.picState === '1' ? 'cas1' : this.picState === '2' ? 'cas3' : 'cas2';
					let option = {
						tooltip: {
							trigger: 'item',
							formatter: "{a} <br/>{b}: {c} ({d}%)"
						},
						legend: {
							orient: 'vertical',
							y: 'center',    //延Y轴居中
							x: 'right', //居右显示
							right: 10,
							top: 'center',
							align: 'left',
							itemGap: 30,
							itemWidth: 8,
							textStyle: {
								fontSize: 14
							},
							data: [
								{ icon: 'circle', name: '1688' },
								{ icon: 'circle', name: '当当' },
								{ icon: 'circle', name: '京东商城' },
								{ icon: 'circle', name: '淘宝网' },
								{ icon: 'circle', name: '天猫商城' },
								{ icon: 'circle', name: '唯品会' },
								{ icon: 'circle', name: '药房网' },
								{ icon: 'circle', name: '1药城' },
								{ icon: 'circle', name: '拼多多' },
								{ icon: 'circle', name: '苏宁' },
								{ icon: 'circle', name: '其他平台' },
							],
							formatter: name => {
								let state = this.picState === '1' ? 'cas1' : this.picState === '2' ? 'cas2' : 'cas3';
								if (this.outNotificationChartData[state]) {
									const item = this.nameData.find(item => {
										return item.name === name;
									})
									return name + '   ' + this.outNotificationChartData[item.value] + ' ' + `(${this.outNotificationChartData[item.value + '_']}%)`
								}
								return name + '   ' + 0 + ' ' + '(0%)';
							},
						},
						color: ['#30cfed', '#8686fa', '#e057f5', '#f5576b', '#f7b33d', '#8300d7', '#f59fbc', '#29c4fe', '#a435ff', '#ed5e00', '#cbb99d', '#31b573', '#a8d59d', '#e1c81d', '#5ca341', '#7a7700'],
						toolbox: {
							right: 20,
							top: 20,
							feature: {
								saveAsImage: {}
							},
							iconStyle: {
								color: '#30cfed'
							}
						},
						graphic: [{
							type: 'text',
							left: String(res[state]).length === 1 ? '33.5%' : String(res[state]).length === 2 ? '30.5%' : '29%',
							top: '45%',
							style: {
								text: res[state],
								fill: '#66666',
								fontSize: 32,
								fontWeight: 'bold'
							}
						}, {
							type: 'text',
							left: '32.5%',
							top: '55%',
							style: {
								text: '总数量',
								fill: '#666666',
								fontSize: 14,
							}
						}],
						series: [
							{
								name: '店铺数量',
								type: 'pie',
								radius: ['55%', '70%'],
								center: ['35%', '50%'],
								avoidLabelOverlap: false,
								label: {
									normal: {
										show: false,
										position: 'left'
									},
								},
								labelLine: {
									normal: {
										show: false
									}
								},
							}
						]
					}
					let data = [];
					this.nameData.forEach((item, index) => {
						if (res[item.value] && res[item.value] !== 0) {
							data.push({ value: res[item.value], name: item.name })
						}
					})
					console.log(data)
					option.series[0].data = data;
					chart.setOption(option);
				})
		},
		onTurnToDetail() {
			console.log(new Date(this.committime[0]).getTime());
			this.$router.push(`/OutNotificationDetail/${this.committime[0]}--${this.committime[1]}`);
			// this.$router.push(`/OutNotificationDetail/${}`);
		}
	},

	computed: {
		...mapState({
			outNotificationData: state => state.outNotification.outNotificationData,
			outNotificationChartData: state => state.outNotification.outNotificationChartData,
			outNotificationList: state => state.outNotification.outNotificationList,
		}),
	},

	created() {
		this.committime = getRecentOneMonth();
		this.load();

	},

	mounted() { },
}
</script>


<style lang='scss'>
.out-rank-three {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 30px;
	height: 30px;
	border-radius: 15px;
	background-color: #c1a870;
	color: #fff;
}

.out-rank {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 30px;
	height: 30px;
}

@import "style/activityDeclaration.scss";
@import "style/outReview.scss";
@import "style/activityApproval.scss";
@import "style/activityApprovalSetting.scss";
</style>
